import React from 'react';
// eslint-disable-next-line no-unused-vars
import 'styled-components/macro';
import Grid from 'components/atoms/Grid';
import Select from 'components/atoms/Select';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function ProductBasicDetails({ form, categoryOpts, industryOpts, styleOpts }) {
  return (
    <>
      <Grid
        xs={1}
        lg={2}
        colGap={20}
        css={`
          align-items: center;
        `}>
        <Form.Item
          sm
          type="text"
          label="Title"
          name="title"
          placeholder="Post Title"
          rules={[{ required: true, message: 'Please enter post title' }]}>
          <Field />
        </Form.Item>
        <Form.Item
          type="text"
          label="SKU"
          maxLength={10}
          name="sku"
          placeholder="sku"
          sm
          rules={[{ required: true, message: 'Please enter sku' }]}>
          <Field />
        </Form.Item>
        <Form.Item
          sm
          isMulti
          options={categoryOpts}
          isSearchable
          name="category"
          label="Category"
          placeholder="Select Category"
          hideSelectedOptions={false}
          closeMenuOnSelect={true}
          rules={[{ required: false, message: 'Select atleast one cateogry' }]}>
          <Select />
        </Form.Item>
        <Form.Item
          sm
          isMulti
          options={industryOpts}
          isSearchable
          name="industry"
          label="Industry"
          placeholder="Select material"
          hideSelectedOptions={false}
          closeMenuOnSelect={true}
          rules={[{ required: false, message: 'Select atleast one cateogry' }]}>
          <Select />
        </Form.Item>
        <Form.Item
          sm
          isMulti
          options={styleOpts}
          isSearchable
          name="style"
          label="style"
          placeholder="Select style"
          hideSelectedOptions={false}
          closeMenuOnSelect={true}
          rules={[{ required: false, message: 'Select atleast one cateogry' }]}>
          <Select />
        </Form.Item>

        <Form.Item
          sm
          type="text"
          label="Metatitle"
          name="metaTitle"
          placeholder="Metatitle"
          rules={[{ required: true, message: 'Please enter meta title' }]}>
          <Field />
        </Form.Item>
        <Form.Item
          sm
          type="text"
          label="Meta Description"
          name="metaDescription"
          placeholder="Metadescription"
          rules={[{ required: true, message: 'Please enter post meta description' }]}>
          <Field />
        </Form.Item>

        <Form.Item
          sm
          type="text"
          label="keywords"
          name="keywords"
          placeholder="Keywords"
          rules={[{ required: true, message: 'Please enter post keywords' }]}>
          <Field />
        </Form.Item>
      </Grid>
      <div className="product-description">
        <Form.Item
          sm
          type="textarea"
          label="Short Description"
          name="shortDescription"
          placeholder="Short Descrption"
          rules={[{ required: true, message: 'Please enter sku' }]}>
          <Field />
        </Form.Item>
      </div>
      <Form.Item
        label="Publish Date"
        type="datepicker"
        name="publishedDate"
        onChange={({ target: { value } }) => {
          form.setFieldsValue({ publishedDate: value });
        }}
        rules={[{ required: false }]}>
        <Field />
      </Form.Item>
    </>
  );
}

export default ProductBasicDetails;
